import { Form, Input, Modal } from 'antd';
import { useUpdate } from '@refinedev/core';

interface PasswordFormValues {
  newPassword: string;
  confirmPassword: string;
}

interface UserEditPasswordModalProps {
  open: boolean;
  onClose: () => void;
  userId: string | undefined;
}

const PASSWORD_MIN = 8;

export function UserEditPasswordModal({
  open,
  onClose,
  userId
}: UserEditPasswordModalProps) {
  const { mutate: updatePassword, isLoading: passwordSubmitting } = useUpdate();
  const [passwordForm] = Form.useForm<PasswordFormValues>();

  const handleOk = async () => {
    try {
      const { newPassword } = await passwordForm.validateFields();

      if (!userId) {
        return;
      }

      updatePassword(
        {
          resource: 'users',
          id: userId,
          values: { password: newPassword },
          successNotification: {
            message: 'Senha atualizada',
            description: 'A senha do usuário foi alterada.',
            type: 'success'
          }
        },
        {
          onSuccess: () => {
            onClose();
            passwordForm.resetFields();
          }
        }
      );
    } catch {
      // validation error
    }
  };

  return (
    <Modal
      title="Alterar senha do usuário"
      open={open}
      onCancel={() => {
        onClose();
        passwordForm.resetFields();
      }}
      onOk={handleOk}
      confirmLoading={passwordSubmitting}
      destroyOnClose
    >
      <Form form={passwordForm} layout="vertical" preserve={false}>
        <Form.Item
          label="Nova senha"
          name="newPassword"
          rules={[
            { required: true, message: 'Informe a nova senha' },
            {
              min: PASSWORD_MIN,
              message: `A senha deve ter pelo menos ${PASSWORD_MIN} caracteres`
            }
          ]}
          hasFeedback
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          label="Confirmar nova senha"
          name="confirmPassword"
          dependencies={['newPassword']}
          hasFeedback
          rules={[
            { required: true, message: 'Confirme a nova senha' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }

                return Promise.reject(new Error('As senhas não coincidem'));
              }
            })
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
